import { render } from "./TvmStructuredSuggestions.vue?vue&type=template&id=c29a15a8&scoped=true"
import script from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"
export * from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"

import "./TvmStructuredSuggestions.vue?vue&type=style&index=0&id=c29a15a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29a15a8"],['__file',"src/components/ChatWidget/TvmStructuredSuggestions/TvmStructuredSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c29a15a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c29a15a8', __exports__)) {
    api.reload('c29a15a8', __exports__)
  }
  
  module.hot.accept("./TvmStructuredSuggestions.vue?vue&type=template&id=c29a15a8&scoped=true", () => {
    api.rerender('c29a15a8', render)
  })

}


export default __exports__